<template>
  <div class="screen-create-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <button class="btn btn-secondary" @click="goBack">
        <i class="fa fa-arrow-left"></i> Volver a la lista
      </button>
    </div>

    <div class="card shadow-sm mb-4">
      <div class="card-body p-4">
        <h5 class="text-center text-dark fs-5 text-uppercase mb-4">
          Diseño del formulario de inscripción
        </h5>
        <div class="row g-4 align-items-end">
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
            <label for="form-control">
              <strong>Ingrese el nombre del formulario</strong>
            </label>
            <input
              type="text"
              class="form-control mt-2 text-uppercase"
              placeholder="Nombre del formulario"
              v-model="form_name"
              oninput="this.value = this.value.toUpperCase()"
            />
          </div>
          <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
            <label for="form-control">
              <strong>Ingrese una breve descripción del formulario</strong>
            </label>
            <input
              type="text"
              class="form-control mt-2 text-uppercase"
              placeholder="Descripción del formulario"
              v-model="form_description"
              oninput="this.value = this.value.toUpperCase()"
            />
          </div>
        </div>
        <div class="row g-4 mt-3 align-items-end">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <label for="form-control">
              <strong>Seleccione la orientación del formulario</strong>
            </label>
            <select
              name="form_oriented"
              class="form-select mt-2"
              v-model="selectedOrientedId"
            >
              <option value="" disabled selected>
                Seleccione la orientación
              </option>
              <option
                v-for="oriented in orienteds"
                :key="oriented.id"
                :value="oriented.id"
              >
                {{ oriented.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 d-flex align-items-end">
            <template v-if="selectedFormType">
              <button
                class="btn btn-outline-secondary w-100"
                data-bs-toggle="modal"
                data-bs-target="#previewModal"
              >
                Vista previa del formulario base
              </button>
              <PreviewModal
                :formType="selectedFormType"
                modalId="previewModal"
              />
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm mb-4">
      <div class="card-body p-4">
        <h4 class="text-center text-dark fs-6 text-uppercase mb-4">
          Parámetros adicionales para el formulario de inscripción
        </h4>
        <div class="row mb-3">
          <div class="col-12">
            <label class="mb-2"
              >Seleccione el tipo de campo a adicionar al formulario</label
            >
            <div class="page-panel-wrapper p-2 bg-white rounded border mb-2">
              <page-panel
                @addComponent="
                  (el) => {
                    settings.drawingList.push(el);
                  }
                "
              ></page-panel>
            </div>
          </div>
        </div>
        <div class="row g-4">
          <div class="col-sm-8 col-12">
            <label for="form-control" class="mb-2"
              >Datos adicionales a incorporar al formulario</label
            >
            <div class="drawer-scroll-wrapper p-2 bg-light rounded border">
              <el-scrollbar class="center-scrollbar" :class="[device, preview]">
                <page-drawer
                  :model-value="settings"
                  @update:model-value="update"
                ></page-drawer>
              </el-scrollbar>
            </div>
          </div>
          <div class="col-sm-4 col-12">
            <div class="setting-panel-wrapper p-2 bg-white rounded border">
              <page-setting
                :model-value="settings"
                @update:model-value="update"
              ></page-setting>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons at the bottom -->
    <div class="d-flex justify-content-center mt-4 mb-2">
      <div class="btn-group action-btn-group">
        <button
          type="button"
          class="btn btn-success btn-lg px-4"
          @click="execDownload('test.vue')"
        >
          <el-icon> <video-play /> </el-icon>
          Registrar
        </button>
        <button
          type="button"
          class="btn btn-danger btn-lg px-4"
          @click="clearn()"
        >
          <el-icon>
            <delete />
          </el-icon>
          Limpiar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// ... script block remains unchanged ...
import axios from "@/includes/connection";
import { inject, onMounted } from "vue";
import PageDrawer from "@/form_builder/components/form/PageDrawer.vue";
import PagePanel from "@/form_builder/components/form/PagePanel.vue";
import PageSetting from "@/form_builder/components/form/PageSetting.vue";
import useClipboard from "vue-clipboard3";
import { useRouter } from "vue-router";
import PreviewModal from "./ModalPreview.vue";

import { ElMessage } from "element-plus";

import { saveAs } from "file-saver";

import {
  deepClone,
  findEle,
  isObjectArray,
  randFieldId,
} from "@/form_builder/utils/func.js";
import { formConf } from "@/form_builder/components/form/ui/index";
import { generate, generateJSON } from "@/form_builder/utils/generate.js";
import {
  Iphone,
  Monitor,
  VideoPlay,
  Delete,
  Download,
  DocumentCopy,
} from "@element-plus/icons-vue";
import { defineComponent, provide, reactive, ref, watch, computed } from "vue";

export default defineComponent({
  name: "PageGenerator",
  props: {},
  components: {
    PagePanel,
    PageSetting,
    PageDrawer,
    DocumentCopy,
    Iphone,
    Monitor,
    VideoPlay,
    Delete,
    Download,
    PreviewModal,
  },
  setup(props, ctx) {
    // ... setup code remains unchanged ...
    const swal = inject("$swal");
    const form_name = ref("");
    const device = ref("pc");
    const showCode = ref(false);
    const preview = ref("");
    const form_description = ref("");
    const orienteds = ref([]);
    const selectedOrientedId = ref("");
    const selectedFormType = ref("");
    const router = useRouter();

    const goBack = () => {
      router.push({ name: "Formularios de Inscripción" });
    };

    const getFormType = (oriented) => {
      if (oriented.mode === "1") {
        return oriented.name === "ESFM" ? "esfm" : "general";
      }
      if (oriented.mode === "2") return "students";
      if (oriented.mode === "3") return "teachers";
      return "";
    };

    const oriented_id = computed(() => {
      const oriented = orienteds.value.find(
        (o) => o.id === selectedOrientedId.value
      );
      return oriented ? oriented.id : null;
    });

    const loadSetting = function () {
      let strs = localStorage.getItem("settings");
      if (strs) {
        return JSON.parse(strs);
      }
      return {
        current: "",
        formConf: formConf,
        drawingList: [],
      };
    };

    const settings = reactive(loadSetting());

    const loadOriented = function () {
      axios
        .get("kind-event/oriented")
        .then((response) => {
          if (response.data) {
            orienteds.value = response.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    onMounted(() => {
      loadOriented();
    });

    watch(selectedOrientedId, (newId) => {
      const oriented = orienteds.value.find((o) => o.id == newId);
      if (oriented) {
        selectedFormType.value = getFormType(oriented);
      } else {
        selectedFormType.value = "";
      }
    });

    const update = function (e) {
      settings.formConf = e.formConf;
      settings.drawingList = e.drawingList;
    };

    const selected = function (s) {
      settings.current = s;
    };

    const clearn = function () {
      localStorage.removeItem("settings");
      settings.current = "";
      settings.formConf = formConf;
      settings.drawingList = [];
    };

    const hightLight = function (s) {
      if (settings.current == s) {
        return { border: "1px solid #ffc92fde", backgroundColor: "#e4ff0024" };
      }
      return {};
    };

    const _del = function (items, _id) {
      for (let item of items) {
        if (item.__ID == _id) {
          items.splice(items.indexOf(item), 1);
          return true;
        } else if (isObjectArray(item.childrens)) {
          if (_del(item.childrens, _id)) {
            return true;
          }
        }
      }
    };

    const deleteItem = function (_id) {
      _del(settings.drawingList, _id);
    };

    const _copy = function (items, _id) {
      for (let item of items) {
        if (item.__ID == _id) {
          const newItem = deepClone(item);
          newItem.__ID = randFieldId();
          items.push(reactive(newItem));
          return true;
        } else if (isObjectArray(item.childrens)) {
          if (_copy(item.childrens, _id)) {
            return true;
          }
        }
      }
    };

    const copyItem = function (_id) {
      _copy(settings.drawingList, _id);
    };

    const updateChild = function (eles, ids) {
      let item = findEle(settings.drawingList, ids);
      item.childrens = eles;
    };

    const updateDefaultValue = function (val, ids) {
      let item = findEle(settings.drawingList, ids);
      item.defaultvalue = val;
    };

    const toVal = function (obj) {
      const _c = {};
      for (let a in obj) {
        if (typeof obj[a] == "object") {
          if ("__val__" in obj[a]) {
            _c[a] = obj[a]["__val__"];
          } else {
            _c[a] = toVal(obj[a]);
          }
        } else {
          _c[a] = obj[a];
        }
      }
      return _c;
    };

    const execDownload = function (filename) {
      const selout = generateJSON(settings);
      const listItems = selout.childrens;
      let itemPersist = [];
      Object.entries(listItems).filter((el) => {
        let my_child = [];
        if (el[1].hasOwnProperty("childrens")) {
          if (el[1].__opt__ && el[1].__opt__.staticData) {
            my_child = el[1].__opt__.staticData.map((option) => ({
              key: option.key,
              value: option.value,
            }));
          } else {
            Object.entries(el[1].childrens).filter((child, idx) => {
              let key = child[1].slots?.default || `Opción ${idx + 1}`;
              let value = child[1].attrs?.label || idx + 1;
              let new_child = {
                key: key,
                value: value,
              };
              my_child.push(new_child);
            });
          }
        }
        let isRequired = false;
        if (
          settings.formConf.__rules &&
          el[1].attrs &&
          el[1].attrs.fieldName &&
          settings.formConf.__rules[el[1].attrs.fieldName.__val__]
        ) {
          const rulesArr =
            settings.formConf.__rules[el[1].attrs.fieldName.__val__];
          isRequired =
            Array.isArray(rulesArr) &&
            rulesArr.some((r) => r.required === true);
        }
        let my_element = {
          label: el[1].formItem.label,
          name: el[1].attrs.fieldName,
          as: el[1].tagIcon,
          type: el[1].attrs?.type,
          children: my_child,
          required: isRequired,
          ...el[1].attrs,
        };
        if (my_element.label && typeof my_element.label === "string") {
          my_element.label = my_element.label.toUpperCase();
        }
        if (my_element.name && typeof my_element.name === "string") {
          my_element.name = my_element.name.toUpperCase();
        }
        if (
          my_element.placeholder &&
          typeof my_element.placeholder === "string"
        ) {
          my_element.placeholder = my_element.placeholder.toUpperCase();
        }
        itemPersist.push(my_element);
      });
      if (form_name.value) form_name.value = form_name.value.toUpperCase();
      if (form_description.value)
        form_description.value = form_description.value.toUpperCase();
      if (form_name.value.length == 0) {
        swal.fire("Se requiere el nombre del formulario", "", "info");
        return;
      }
      if (form_description.value.length == 0) {
        swal.fire("Se requiere la descripción del formulario", "", "info");
        return;
      }
      if (!selectedFormType.value) {
        swal.fire("Debe seleccionar un tipo de formulario", "", "info");
        return;
      }
      if (!localStorage.getItem("User")) {
        return;
      }
      swal
        .fire({
          title: "¿Está seguro?",
          text: "Se registrarán nuevos campos específicos para un formulario.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Registrar Evento",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            const user = JSON.parse(localStorage.getItem("User"));
            const request = {
              html: JSON.stringify(itemPersist),
              detail: form_name.value,
              description: form_description.value,
              oriented_id: oriented_id.value,
              user_id: user.id,
            };
            axios
              .post("/enrollment-form", request)
              .then((response) => {
                swal
                  .fire({
                    title: "Registro Exitoso!!!",
                    icon: "success",
                  })
                  .then(() => {
                    localStorage.setItem("formCreatedFlag", "true");
                    router.push({ name: "Formularios de Inscripción" });
                  });
                form_name.value = "";
                form_description.value = "";
                selectedFormType.value = "";
                clearn();
              })
              .catch(function (error) {
                console.log(error);
                if (error.response.status == 409) {
                  let msg =
                    "Ya existe un formulario con ese nombre, por favor ingrese otro nombre";
                  swal.fire({
                    title: "Registro fallido!!!",
                    text: msg,
                    icon: "warning",
                  });
                  return;
                } else {
                  swal.fire({
                    title: "Registro fallido!!!",
                    icon: "warning",
                  });
                }
              });
          }
        });
    };
    const preViewCode = function () {
      showCode.value = true;
    };
    const { toClipboard } = useClipboard();
    const ClipboardWrite = async () => {
      const codeStr = generate(settings);
      try {
        await toClipboard(codeStr);
        ElMessage("Acción Exitosa");
      } catch (e) {
        console.error(e);
      }
    };
    watch(settings, () => {
      localStorage.setItem("settings", JSON.stringify(settings));
    });
    provide("copyItem", copyItem);
    provide("deleteItem", deleteItem);
    provide("selected", selected);
    provide("updateChild", updateChild);
    provide("hightLight", hightLight);
    provide("updateDefaultValue", updateDefaultValue);
    return {
      settings,
      update,
      device,
      clearn,
      preview,
      generate,
      generateJSON,
      execDownload,
      showCode,
      preViewCode,
      ClipboardWrite,
      form_name,
      selectedFormType,
      selectedOrientedId,
      orienteds,
      oriented_id,
      form_description,
      goBack,
    };
  },
});
</script>

<style lang="scss">
@import "@/form_builder/styles/home";
@import "@/form_builder/styles/index";

.screen-create-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 0 32px 0;
}
.card.shadow-sm {
  border-radius: 16px;
  border: none;
}
.card-body {
  background: #f9fafd;
  border-radius: 16px;
}
.page-panel-wrapper {
  min-height: 60px;
}
.drawer-scroll-wrapper {
  min-height: 220px;
  max-height: 350px;
  overflow-y: auto;
}
.setting-panel-wrapper {
  min-height: 220px;
}
.action-btn-group {
  gap: 16px;
}
</style>
